import React from 'react';
import { sumAllEnergy } from './SumUtils';
import ProgressBar from 'react-bootstrap/ProgressBar';
import './sum.css'

class Sum extends React.Component {

    constructor(props) {
        super(props);
    }

    properRounding (number) {
        if (number < 1) {
            number = number.toFixed(4)
        } else if (number < 10) {
            number = number.toFixed(3)
        } else if (number < 100) {
            number = number.toFixed(2)
        } else if (number < 1000) {
            number = number.toFixed(1)
        } else if (number < 10000) {
            number = number.toFixed(0)
        }
        
        return number;
    }

    calculateSum() {
        
        let eIn = this.props.energyIn
        let eOut = this.props.energyOut

        

        return (
        <>
        <table
        style={{
            position: 'absolute',
            left: '20%',

        }}>
            <tr>
                <td>In: </td>
                <td>{this.properRounding(eIn)}</td>
            </tr>
            <tr>
                <td>Out: </td>
                <td>{this.properRounding(eOut)}</td>
            </tr>

        </table>
        </>);
    }

    subTotal() {



        let eIn = this.props.energyIn
        let eOut = this.props.energyOut
        let myFontSize = this.props.myFontSize;
        let sum = eIn + eOut;
        let color;
        let percentage;



        let EnergyMappedToProgressBar = this.props.energy.map((info, index) => {
            color = info.color;
            percentage = (info.energyKWh/sum)



            
            if(this.props.energy.length == 1){
                percentage = 100;
            }
            
            return (
                <ProgressBar 
                style = {{
                    backgroundColor: color
                }}
                striped variant now = {percentage * 100}/>
            );

        })    

        return (
        <div key={sum}>
        <div 
        id = {this.props.side + "badge"}
        style={{
           fontSize: `${myFontSize}vh`,
        }}
        >
            {this.properRounding((this.props.energyIn+this.props.energyOut))}kWh
        </div>
        <div
        style={{height:"1px"}}/>
        {(this.props.rectangle.powerType != "NOPOWER") ? 
        <ProgressBar
        style={{
            height: `${(this.props.length / 3 ) / 1.4}vh`
        }}>
            {EnergyMappedToProgressBar}
        </ProgressBar> : null}
        </div> 
        );
    }

    render () {
        return (
            <>
                {this.props.App
                ?

                this.calculateSum():

                this.subTotal()}
            </>
        )
    }
}

export default Sum;